import React, { ReactNode } from 'react';
import { Modal, IconSvg, helperMargin, Typography, Separator, IconSvgProps } from '@utex/ui-kit';
import { observer } from 'mobx-react';
import { Content, Wrapper, Footer } from './styles';
import { useModalService } from '../../../hooks/useModalService';

export type Icon = 'success' | 'fail';

interface Props {
  icon?: Icon;
  title?: string;
  footer?: ReactNode;
  children?: ReactNode;
  testId?: string;
  backgroungColor?: string;
}

const iconToSrc: Record<Icon, IconSvgProps['src']> = {
  success: 'accept',
  fail: 'decline',
};

export const BaseModal: React.FC<Props> = observer(
  ({ title, footer, children, icon, testId, backgroungColor }) => {
    const { isOpened, closeImmediately } = useModalService();
    return (
      <Modal isOpen={isOpened} onRequestClose={closeImmediately} testId={testId}>
        <Content backgroungColor={backgroungColor}>
          <Wrapper>
            {title && (
              <>
                {icon && (
                  <IconSvg
                    src={iconToSrc[icon]}
                    width={80}
                    height={80}
                    css={helperMargin({ bottom: 20 })}
                  />
                )}
                <Typography.Title level={2}>{title}</Typography.Title>
                <Separator />
              </>
            )}
            {children}
          </Wrapper>
          {footer && <Footer>{footer}</Footer>}
        </Content>
      </Modal>
    );
  }
);
